import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '../core/translate/translate.module';
import { PreventDefaultDirectiveModule } from '../shared/directives/prevent-default.directive';
import { SocketsManagerComponent } from './organisms';

@NgModule({
  declarations: [
    SocketsManagerComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    PreventDefaultDirectiveModule
  ],
  exports: [
    SocketsManagerComponent
  ]
})
export class SocketsManagerModule { }
